import {useMemo} from 'react';

// import {Product} from '@/services/product/types';

import {useAppSelector} from 'hooks';
import {Product} from 'types';
import {getProductAvailability} from 'utils';

export function useProductAvailability(product: Product) {
  const {currentStore, defaultMembershipCard} = useAppSelector((state) => state?.app);
  return useMemo(() => {
    return getProductAvailability(product, currentStore?.storeCodes || [], {
      alcoholExpiryDate: defaultMembershipCard?.alcoholExpiryDate
    });
  }, [currentStore?.storeCodes, product, defaultMembershipCard?.alcoholExpiryDate]);
}
